import React from "react";

export default function SubscriptionTnC() {
  return (
    <div
      className="
        rounded-3xl
        border border-red-500/30
        bg-red-950/20
        p-5
      "
    >
      <h2 className="font-bold text-red-300 mb-4">
        📜 Subscription Terms & Refund Policy
      </h2>

      <ul className="space-y-3 text-sm text-red-100 [&_li]:text-gray-100 leading-relaxed">
        <li>
          1. Payments are made towards digital subscriptions,
          memberships, software access, learning resources,
          services, and related digital offerings provided on an
          "as-is" basis. Once access is granted or the service is
          used, payments are non-refundable.
        </li>

        <li>
          2. Users must review subscription plans, pricing,
          features, eligibility criteria, and validity before
          making payment. Change of mind, accidental purchase, or
          non-usage does not qualify for refunds.
        </li>

        <li>
          3. Duplicate transactions, technical payment errors, or
          incorrect debits verified by the company and payment
          provider may be reviewed for adjustment or refund.
        </li>

        <li>
          4. Subscription benefits, credits, digital access,
          memberships, and usage rights are non-transferable unless
          explicitly stated otherwise.
        </li>

        <li>
          5. By completing payment, the purchaser acknowledges and
          agrees to the applicable Terms, Privacy Policy, Refund
          Policy, and compliance requirements of Think5Whys Global
          DeepTech Solution Private Limited.
        </li>

        {/* Data Protection Points */}
        <li>
            6. Think5Whys is committed to protecting user information and
            applies reasonable administrative, technical, and organizational
            measures to safeguard personal and business data against
            unauthorized access, disclosure, alteration, or misuse.
            </li>

            <li>
            7. User information collected during registration, subscriptions,
            payments, onboarding, learning activities, and platform usage
            shall be processed in accordance with the applicable Privacy
            Policy and relevant data protection requirements.
            </li>

            <li>
            8. Users are responsible for maintaining the confidentiality of
            their login credentials, account access, and verification details.
            Think5Whys shall not be responsible for losses arising from
            unauthorized access resulting from credential sharing,
            negligence, or compromised user devices.
            </li>
      </ul>
    </div>
  );
}